import request from '@/assets/js/utils/request'
import config from '@/assets/js/conf/config'

const root = `${config.baseApi}/merchant/product/import/link`

export const getAgreement = () => request.get(`${root}/agreement`, {})
export const signAgreement = data => request.post(`${root}/agreement/sign`, data)
export const createLinkTask = data => request.post(`${root}/tasks/create`, data)
export const getLinkTasks = () => request.get(`${root}/tasks`, {})
export const claimLinkItem = data => request.post(`${root}/tasks/claim`, data)
export const reportLinkItem = data => request.post(`${root}/tasks/report`, data)
export const waitForLinkPlugin = data => request.post(`${root}/tasks/wait`, data)
export const finishLinkTask = data => request.post(`${root}/tasks/finish`, data)
